export const DEFAULT_PANEL_TYPE_IMAGE_1X1 = 1;
export const DEFAULT_PANEL_TYPE_IMAGE_1X2 = 2;
export const DEFAULT_PANEL_TYPE_IMAGE_2X1 = 3;
export const DEFAULT_PANEL_TYPE_IMAGE_3X1 = 4;
export const DEFAULT_PANEL_TYPE_IMAGE_2X2 = 5;
export const DEFAULT_PANEL_TYPE_IMAGE_3X2 = 6;

export const DEFAULT_PANEL_NAME = {
  DEFAULT_PANEL_TYPE_IMAGE_1X1: '1x1',
  DEFAULT_PANEL_TYPE_IMAGE_1X2: '1x2',
  DEFAULT_PANEL_TYPE_IMAGE_2X1: '2x1',
  DEFAULT_PANEL_TYPE_IMAGE_3X1: '3x1',
  DEFAULT_PANEL_TYPE_IMAGE_2X2: '2x2',
  DEFAULT_PANEL_TYPE_IMAGE_3X2: '3x2',
};
